/**
 * Enum for authentication tab types
 * Used for query params and tab synchronization
 */
export enum AuthTab {
  LOGIN = 'login',
  REGISTER = 'register'
}

/**
 * Map of tab values to display labels
 */
export const AUTH_TAB_LABELS: Record<AuthTab, string> = {
  [AuthTab.LOGIN]: 'Accedi',
  [AuthTab.REGISTER]: 'Registrati'
};

/**
 * Type guard to check if a value is a valid AuthTab
 */
export function isAuthTab(value: string | undefined | null): value is AuthTab {
  return value === AuthTab.LOGIN || value === AuthTab.REGISTER;
}

/**
 * Get tab from string value with fallback
 */
export function getAuthTabFromString(value: string | undefined | null): AuthTab {
  return isAuthTab(value) ? value : AuthTab.LOGIN;
}